import { Grid, Box } from "@material-ui/core";
import useCustomState from "../../hooks/State";
import { calculateNumPages, getPageNumbers } from "../../utils/paginator";
import Item from "./Item";

const Paginator = (props) => {
  const numPage = calculateNumPages(props.items, props.pageSize);

  const pageNumbers = getPageNumbers(props.selectedPage, numPage, 2);

  const selectedPageChanged = (newNumber) => {
    props.selectedPageChanged(newNumber);
  };

  const renderItems = () => {
    if (numPage === 0 || numPage === 1) {
      return null;
    } else {
      return pageNumbers.map((num, idx) => {
        const selected = num === props.selectedPage ? true : false;
        return (
          <Item
            number={num}
            key={idx}
            selected={selected}
            selectedChanged={selectedPageChanged}
          />
        );
      });
    }
  };

  return (
    <Grid
      xs={12}
      sm={12}
      md={12}
      lg={12}
      style={{
        paddingTop: "12px",
        paddingBottom: "12px",
        border: "1px solid #333333",
        borderRadius: "6px",
      }}
    >
      <Box
        style={{
          display: "flex",
        }}
      >
        <div
          style={{
            display: "flex",
            margin: "0 auto",
            borderRadius: "4px",
          }}
        >
          {renderItems()}
        </div>
      </Box>
    </Grid>
  );
};

export default Paginator;
